import { PropsWithChildren } from 'react';
import { Button, CloseButton, Modal } from 'react-bootstrap';

export enum VerbiageType {
    YesNo = 'YesNo',
    OkCancel = 'OkCancel',
}

export type ConfirmationModalProps = PropsWithChildren<{
    show: boolean;
    enabled: boolean;
    title: String;
    onCancel: () => void;
    onConfirm: () => void;
    onEntered?: () => void;
    verbiageType: VerbiageType;
}>;

export function ConfirmationModal(props: ConfirmationModalProps) {
    const verbiage = {
        [VerbiageType.YesNo]: { confirm: 'Yes', cancel: 'No' },
        [VerbiageType.OkCancel]: { confirm: 'OK', cancel: 'Cancel' },
    };
    const { confirm: confirmText, cancel: cancelText } = verbiage[props.verbiageType];

    return (
        <ConfirmationCustomModal
            show={props.show}
            enabled={props.enabled}
            cancelVariant="light"
            cancelText={cancelText}
            confirmVariant="primary"
            confirmText={confirmText}
            title={props.title}
            onCancel={props.onCancel}
            onConfirm={props.onConfirm}
            onEntered={props.onEntered}
        >
            {props.children}
        </ConfirmationCustomModal>
    );
}

export type ConfirmationCustomModalProps = PropsWithChildren<{
    show: boolean;
    enabled: boolean;
    title: String;
    onCancel: () => void;
    onConfirm: () => void;
    onEntered?: () => void;
    cancelVariant: string;
    confirmVariant: string;
    cancelText?: string;
    confirmText?: string;
}>;

export function ConfirmationCustomModal(props: ConfirmationCustomModalProps) {
    const enabledCss = props.enabled ? '' : 'disabled';
    return (
        <>
            <Modal size="lg" centered show={props.show} onEntered={props.onEntered}>
                <Modal.Header>
                    <Modal.Title>{props.title}</Modal.Title>
                    <CloseButton onClick={() => props.onCancel()} />
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
                <Modal.Footer>
                    <Button variant={props.cancelVariant} onClick={() => props.onCancel()}>
                        {props.cancelText}
                    </Button>
                    <Button variant={props.confirmVariant} className={enabledCss} onClick={() => props.onConfirm()}>
                        {props.confirmText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
